var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"show-tag-columns":true,"show-tag-filter":true,"export-data-options":_vm.exportDataOptions,"group-actions":_vm.groupActions,"showSearchbox":_vm.showSearchbox,"showGroupActions":_vm.showGroupActions,"single-actions":_vm.singleActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }